import React, { PureComponent } from 'react';
import { Typeahead } from 'react-typeahead';
import axios from 'axios';

class JobSearch extends PureComponent {
    componentDidMount() {
        this.focusInput();
    }

    state = {
        isSearching: false,
        options: []
    };

    focusInput() {
        const input = document.querySelector('.typeahead > input');
        input.focus();
    }


    async handleKeyUp() {
        const input = document.querySelector('.typeahead > input');
        const value = input.value;

        if (value != '' && value.length > 1) {
            const results = await axios.get(
                process.env.CMS_URL + `/getSoc/${input.value}`
            );
            this.setState({
                options: results.data
            });
        } else {
            this.setState({
                options: []
            });
        }
    }

    handleSelection(selected) {
        const { options } = this.state;
        const { setSoc } = this.props;
        const selectedJob = options.find(option => option.job_title == selected);
        setSoc(selectedJob.soc, selected);
    }

    render() {
        const { isSearching, options } = this.state;
        const { jobTitle } = this.props;

        return (
            <div className="jobsearch">
                <h4 className="jobsearch-title">What is your job title?</h4>
                <p className="jobsearch-subtitle">Please be as specific as you can and use words that describe, for example, what kind of manager, cleaner, technician or driver you are.</p>    
                <Typeahead 
                    onKeyUp={() => this.handleKeyUp()} 
                    options={options.map(option => option.job_title)} 
                    value={jobTitle ? jobTitle : ''}
                    onOptionSelected={(option) => this.handleSelection(option)}
                />
            </div>
        );
    }
}

export default JobSearch;



// WEBPACK FOOTER //
// ./src/Question/JobSearch.js